// Empty string -> relative paths, i.e. same-origin (production, reverse-proxied
// through the site's own domain). Local dev overrides this via .env, since the
// dev frontend (localhost:3000) and API (localhost:4000) run on different ports.
const API_URL = process.env.REACT_APP_API_URL || '';

async function handle(res) {
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Request failed with status ${res.status}`);
    }
    if (res.status === 204) return null;
    return res.json();
}

export async function fetchMe() {
    const res = await fetch(`${API_URL}/api/auth/me`, {credentials: 'include'});
    const data = await handle(res);
    return data.user;
}

export async function register({email, password, displayName}) {
    const res = await fetch(`${API_URL}/api/auth/register`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email, password, displayName}),
    });
    const data = await handle(res);
    return data.user;
}

export async function login({email, password}) {
    const res = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email, password}),
    });
    const data = await handle(res);
    return data.user;
}

export async function logout() {
    const res = await fetch(`${API_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
    });
    await handle(res);
}
